module.exports = __webpack_public_path__ + "static/media/overlay-color@3x.aa81582a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/WorkoutPlanBackgrounds/bg7/overlay-color@3x.png
// module id = 1237
// module chunks = 2